import { template } from "@ember/template-compiler";
import RouteTemplate from 'ember-route-template';
import WrModalContent from 'ember-wiser/components/wr/modal/content';
import WrDivider from 'ember-wiser/components/wr/divider';
import WrLinkTo from 'ember-wiser/components/wr/link-to';
import WrAnchor from 'ember-wiser/components/wr/anchor';
import TestEnvFeature from 'core/components/test-env-feature';
import LayoutPatientWebRequestAccessToken from 'core/components/layout/patient-web/request-access-token';
const authenticationUrls = [
    'nw',
    'ow',
    'mw',
    'rw'
].map((e1)=>({
        url: `/s/Patient0${e1}`,
        email: `patient-zero+${e1}@semeia.io`
    }));
const PatientWebLogin = template(`
  <WrModalContent @targetModal='login-modal' @title='Connexion patient'>
    <div class='flex flex-col items-center gap-6'>
      <h2 class='text-h2 text-purple text-center font-sans'>
        Recevoir un lien de connexion
        <br />
        par e-mail ou SMS
      </h2>

      <LayoutPatientWebRequestAccessToken />

      <WrDivider>ou</WrDivider>

      <WrLinkTo @route='login.patient-password' class='text-center'>
        Je me connecte avec mon mot de passe
      </WrLinkTo>

      <WrLinkTo @route='login.patient-password-forgotten' class='text-center'>
        Je crée mon mot de passe
      </WrLinkTo>

      <TestEnvFeature>
        <WrDivider>ou</WrDivider>

        <div class='flex flex-col'>
          {{#each authenticationUrls as |patient|}}
            <WrAnchor
              href={{patient.url}}
              class='text-center text-sm sm:text-base'
            >
              ✨ Login as
              {{patient.email}}
              ✨
            </WrAnchor>
          {{/each}}
        </div>
      </TestEnvFeature>
    </div>

  </WrModalContent>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(PatientWebLogin);
